var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable default-case-last */
// eslint-disable-next-line import/no-extraneous-dependencies
import { get } from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import * as yup from 'yup';
import DatePicker from '../components/FormControls/DatePicker';
import TextAreaInput from '../components/FormControls/TextAreaInput';
import TextInput from '../components/FormControls/TextInput';
import { resolveValue, useFormFieldErrorMessage, } from './FormStore';
var FormField = function (_a) {
    var name = _a.name, store = _a.store, configuration = _a.configuration, _b = _a.validationOptions, validationOptions = _b === void 0 ? {
        validate: true,
    } : _b, children = _a.children;
    var value = store(function (state) { return get(state, name); });
    var isDirty = store(function (state) { return state.isDirty; })(name);
    var formSchema = store(function (state) { return state.schema; });
    var errorMessage = useFormFieldErrorMessage(name, value, formSchema, isDirty, validationOptions);
    var updateField = store(function (state) { return state.updateField; });
    var onChange = function (event) { return updateField(name, resolveValue(event)); };
    var props = {
        value: value,
        onChange: onChange,
        errorMessage: errorMessage,
    };
    return (_jsx(_Fragment, { children: children && !configuration ? children(props) : buildFormField(props, configuration) }));
};
var FormBuilderSection = function (_a) {
    var configuration = _a.configuration, store = _a.store;
    return (_jsxs("div", { children: [_jsx("h1", { className: "mb-3 text-lg", children: configuration.key }), configuration.fields.map(function (field) { return (_jsx(FormField, { name: "".concat(configuration.key, ".").concat(field.id), configuration: field, store: store })); })] }));
};
function buildFormField(props, configuration) {
    // eslint-disable-next-line default-case
    switch (configuration.type) {
        case 'text':
            return (_jsx(TextInput, { id: configuration.id, type: "text", label: configuration.label, htmlName: configuration.id, value: props.value, onChange: props.onChange, error: props.errorMessage, required: configuration.required }));
        case 'textarea':
            return (_jsx(TextAreaInput, { id: configuration.id, label: configuration.label, htmlName: configuration.id, value: props.value, onChange: props.onChange, error: props.errorMessage, required: configuration.required }));
        case 'date':
            return (_jsx(DatePicker, { id: configuration.id, label: configuration.label, htmlName: configuration.id, selected: props.value, setSelected: props.onChange }));
    }
}
function buildSchema(sections) {
    return yup.object().shape(sections.reduce(function (prev, next) {
        var _a;
        return (__assign(__assign({}, prev), (_a = {}, _a[next.key] = yup.object().shape(next.fields.reduce(function (fieldPrev, fieldNext) {
            var _a;
            return (__assign(__assign({}, fieldPrev), (_a = {}, _a[fieldNext.id] = buildFieldSchema(fieldNext), _a)));
        }, {})), _a)));
    }, {}));
}
function buildFieldSchema(configuration) {
    var fieldSchema = null;
    switch (configuration.type) {
        case 'text':
        case 'textarea':
        default:
            fieldSchema = yup.string();
            break;
        case 'date':
            fieldSchema = yup.date();
            break;
    }
    if (configuration.required) {
        fieldSchema = fieldSchema.required(configuration.errorMessage);
    }
    else {
        fieldSchema = fieldSchema.nullable();
    }
    return fieldSchema;
}
export { FormField as default, FormBuilderSection, buildSchema };
